<template>
    <div class="countDown">
        <div class="overlay"></div>
        <div class="content">
            <h2>{{ getString('esta_por_ai') }}</h2>
            <h2>{{ getString('seu_pedido_te_espera') }}</h2>

            <span v-text="countDown + 's'"></span>
            <span v-text="getString('para_expirar')"></span>

            <h2>{{ getString('toque_para_voltar_ao_pedido') }}</h2>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'

export default {
    name: 'finalCountDown',
    props: ['countDown'],
    data () {
        return {
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .countDown {
        display: block;
        z-index: 10;
        .full;
        .overlay {
            .full;
            background: black;
            opacity: .6;
        }
        .content{
            position: absolute;
            background: white;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            padding: 30px;
            font-size: 2.5rem;
            width: 700px;
            border-radius: 15px;
            border: solid 5px @primary-dark;
            h2 {
                position: relative;
                display: block;
                padding: 15px 0;
            }
            span {
                font-size: 2.5rem;
                display: block;
                &:first-of-type{
                    font-size: 4rem;
                    color: @primary-color
                }
            }
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        .countDown {
            .content{
                padding: 15px;
                font-size: 20px;
                width: 350px;
                h2 {
                    padding: 5px 0;
                }
                span {
                    font-size: 20px;
                    &:first-of-type{
                        font-size: 40px;
                    }
                }
            }
        }
    }

    @media (orientation: landscape) {
        .countDown {
            .content{
                padding: 15px;
                font-size: 20px;
                width: 350px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/finalCountDown.vue